export enum LocalStorageEnum {
	CONFIRMATION_EMAIL_POP_UP = 'confirmation_email_pop_up',
	TOKEN_EXPIRED = 'expired_token',
	DECONNEXION = 'deconnexion'
}